import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle, roundedPoly, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const SHELL = 0x6a4ad0; // phase-violet hull
const GLOW = 0xd05ab0;

/**
 * C6 Quartet clone — four identical phase ships holding formation.
 * Frame 0 normal / 1 enraged (survivor pair). Nose points +X.
 */
export const bossQuartetClone: ProceduralDef = {
  key: 'boss/quartet/clone',
  width: 92,
  height: 92,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const enraged = frame === 1;

    // Angular phase-ship hull — squashed hex dart
    roundedPoly(
      ctx,
      [
        [c + 34, c],
        [c + 10, c - 26],
        [c - 22, c - 20],
        [c - 32, c],
        [c - 22, c + 20],
        [c + 10, c + 26],
      ],
      8,
    );
    fillOutlined(ctx, SHELL, 6);

    // Mirror seam — these are clones, the symmetry should show
    ctx.strokeStyle = css(shade(SHELL, 0.6));
    ctx.lineWidth = 3.5;
    ctx.beginPath();
    ctx.moveTo(c + 30, c);
    ctx.lineTo(c - 28, c);
    ctx.stroke();

    // Formation pips: four dots marking the quartet bond
    ctx.fillStyle = css(enraged ? COLORS.dangerRed : GLOW);
    for (const [px, py] of [[-14, -10], [-14, 10], [0, -14], [0, 14]] as const) {
      circle(ctx, c + px, c + py, 3);
      ctx.fill();
    }

    // Core eye
    circle(ctx, c + 12, c, enraged ? 10 : 8);
    fillOutlined(ctx, enraged ? COLORS.dangerRed : GLOW, 3.5);
    circle(ctx, c + 15, c - 3, 2.5);
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.fill();
    if (enraged) {
      circle(ctx, c + 12, c, 16);
      ctx.fillStyle = 'rgba(217, 43, 43, 0.22)';
      ctx.fill();
    }
    void h;
  },
};
